var React = require('react');

function Photo (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("rect",{"stroke":"#166C81","strokeWidth":"2","x":"1","y":"1","width":"30","height":"20","rx":"4","key":0}),React.createElement("circle",{"stroke":"#166C81","strokeWidth":"2","cx":"16","cy":"11","r":"6","key":1}),React.createElement("circle",{"fill":"#166C81","cx":"5","cy":"5","r":"1","key":2})]));
}

Photo.defaultProps = {"width":"32","height":"22"};

module.exports = Photo;

Photo.default = Photo;
